import { Box, Stack } from '@mui/material';
import { ConditionMode } from '@synergy/models';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { ReactElement } from 'react';

import { BonusCondition } from '../../models/bonus-condition';

export interface BonusConditionsPresenterProps {
    supplierConditions: BonusCondition[];
}

export const BonusConditionsPresenter = (props: BonusConditionsPresenterProps): ReactElement | null => {
    const { supplierConditions } = props;

    return (
        <Stack>
            {supplierConditions.map((condition: BonusCondition) => {
                const { price, percentage, title, quantity, mode, description, currency, unit } = condition;
                const hasAmount = price && quantity && mode === ConditionMode.Amount;
                const hasPercentage = percentage && mode === ConditionMode.Percentage;

                if (!hasAmount && !hasPercentage) {
                    return null;
                }

                return (
                    <Box key={condition.id}>
                        {hasPercentage && (
                            <FormattedMessage
                                id="app.article.detail.poolBonus.percent"
                                values={{
                                    title: description || title,
                                    percent: (
                                        <FormattedNumber
                                            value={percentage}
                                            style="unit"
                                            unit="percent"
                                            minimumFractionDigits={2}
                                        />
                                    ),
                                }}
                            />
                        )}
                        {hasAmount && (
                            <FormattedMessage
                                id="app.article.detail.poolBonus.amount"
                                values={{
                                    title: description || title,
                                    value: (
                                        <FormattedNumber
                                            value={price}
                                            style="currency"
                                            currency={currency}
                                            minimumFractionDigits={2}
                                        />
                                    ),
                                    amount: <FormattedNumber value={quantity} />,
                                    unit: unit && <FormattedMessage id={`app.enum.${unit}`} />,
                                }}
                            />
                        )}
                    </Box>
                );
            })}
        </Stack>
    );
};
